import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SyncCookieService } from '../../core/sync-cookie.service';
import { environment } from '../../../environments/environment';
import { DialogContactSupportComponent } from '../../account/dialog-contact-support/dialog-contact-support.component';
import { ActivatedRoute } from '@angular/router';
import { DialogCancelComponent } from 'src/app/account/dialog-cancel/dialog-cancel.component';

@Component({
    selector: 'sync-account-hold',
    templateUrl: './account-hold.component.html'
})
export class AccountHoldComponent implements OnInit {

    public isChild: boolean;
    public validRenewLink: boolean;
    constructor(
        private cookie: SyncCookieService,
        private modalService: NgbModal,
        private route: ActivatedRoute
    ) { }

    ngOnInit() {
        console.log(this.route.snapshot.queryParams);
        this.isChild = (this.route.snapshot.queryParams['type'] == 'childuser');
        this.validRenewLink = (this.route.snapshot.queryParams['session_id']);
    }

    public renewAcctHold() {
        this.cookie.setOrderSessionId(this.route.snapshot.queryParams['session_id']);
        window.location.href = environment.ordershost + '/invoice';
    }
    public openContactSupport() {
        const ref = this.modalService.open(DialogContactSupportComponent, {
            backdropClass: 'in',
            windowClass: 'in',
            backdrop: 'static',
        });
    }
    public openCloseAcct() {
        const ref = this.modalService.open(DialogCancelComponent, {
            backdropClass: 'in',
            windowClass: 'in',
            backdrop: 'static',
        });
        ref.componentInstance.userId = parseInt(this.route.snapshot.queryParams['user'], 10);
        ref.componentInstance.plan = parseInt(this.route.snapshot.queryParams['p'], 10);
        ref.componentInstance.sig = this.route.snapshot.queryParams['sig'];
        ref.componentInstance.isAccthold = true;
        ref.result.then((result) => {
            if (result === true) {
            }
        });
    }
}
